import { useState, useRef, useCallback, useEffect } from 'react';
import { SCROLL_BOTTOM_THRESHOLD_PX } from '../constants';

export function useChatScroll(messages, isLoading) {
  const messagesEndRef = useRef(null);
  const messagesContainerRef = useRef(null);
  const [showScrollBtn, setShowScrollBtn] = useState(false);

  const scrollToBottom = useCallback((smooth = true) => {
    messagesEndRef.current?.scrollIntoView({ behavior: smooth ? 'smooth' : 'auto' });
  }, []);

  useEffect(() => {
    scrollToBottom();
  }, [messages, isLoading, scrollToBottom]);

  const handleMessagesScroll = useCallback(() => {
    const el = messagesContainerRef.current;
    if (!el) return;
    const distanceFromBottom = el.scrollHeight - el.scrollTop - el.clientHeight;
    setShowScrollBtn(distanceFromBottom > SCROLL_BOTTOM_THRESHOLD_PX);
  }, []);

  const hideScrollButton = useCallback(() => {
    setShowScrollBtn(false);
  }, []);

  return {
    messagesEndRef,
    messagesContainerRef,
    showScrollBtn,
    scrollToBottom,
    handleMessagesScroll,
    hideScrollButton
  };
}
